/**
 * External dependencies
 */
import { TabulatorFull as Tabulator } from 'tabulator-tables';

const PerformanceTable = ( () => {
	function init() {
		const performanceTables = document.querySelectorAll( '.is-style-performance-table' );

		performanceTables.forEach( ( table ) => {
			try {
				const jsonData = JSON.parse( table.dataset.table );

				const headers = jsonData[ '0' ]; // Use the first entry as headers
				const data = Object.keys( jsonData ).slice( 1 ).map( ( key ) => {
					const obj = {};
					Object.keys( jsonData[ key ] ).forEach( ( colKey ) => {
						obj[ colKey ] = jsonData[ key ][ colKey ];
					} );
					return obj;
				} );

				const columns = Object.keys( headers ).map( ( header, index ) => {
					return {
						title: headers[ index ],
						field: header,
						sorter: 'number',
						resizable: false,
					};
				} );

				new Tabulator( table, {
					data,
					columns,
					layout: 'fitColumns',
					resizableRows: false,
					resizableColumns: false,
					selectableRange: false,
					selectableRows: false,
					autoResize: false,
					initialSort: [
						{ column: '1', dir: 'desc' },
					],
				} );
			} catch ( e ) {
				table.innerHTML = `<p>There was an error loading the table data: ${ e.message }</p>`;
			}
		} );
	}

	return {
		init,
	};
} )();

export default PerformanceTable;
